import { render, staticRenderFns } from "./jyj_baoxian.vue?vue&type=template&id=62e72022&scoped=true"
import script from "./jyj_baoxian.vue?vue&type=script&lang=js"
export * from "./jyj_baoxian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e72022",
  null
  
)

export default component.exports